import { z } from 'zod';
import { LiveChatMessageSchema } from './chatbot.js';
// ============================================================
// 고객센터 문의 (Contact Inquiry)
// ============================================================
export const ContactInquiryCategorySchema = z.enum([
    'BUG',
    'PAYMENT',
    'ACCOUNT',
    'FEATURE',
    'OTHER',
]);
export const CONTACT_INQUIRY_CATEGORY_LABELS = {
    BUG: '버그/오류',
    PAYMENT: '결제',
    ACCOUNT: '계정',
    FEATURE: '기능 제안',
    OTHER: '기타',
};
export const SubmitContactInquiryRequestSchema = z.object({
    name: z.string().min(1, '이름을 입력하세요').max(50, '이름은 50자를 초과할 수 없습니다'),
    email: z.string().email('올바른 이메일을 입력하세요').max(255),
    category: ContactInquiryCategorySchema,
    message: z
        .string()
        .min(10, '문의 내용을 10자 이상 입력하세요')
        .max(5000, '문의 내용은 5000자를 초과할 수 없습니다'),
});
export const SubmitContactInquiryResponseSchema = z.object({
    id: z.string().cuid2(),
});
export const ContactInquiryStatusSchema = z.enum(['UNREAD', 'READ', 'RESOLVED']);
export const CONTACT_INQUIRY_STATUS_LABELS = {
    UNREAD: '미확인',
    READ: '확인',
    RESOLVED: '답변완료',
};
export const UpdateContactInquiryStatusRequestSchema = z.object({
    status: ContactInquiryStatusSchema,
});
export const ReplyContactInquiryRequestSchema = z.object({
    subject: z.string().min(1, '제목을 입력하세요').max(200, '제목은 200자를 초과할 수 없습니다'),
    body: z.string().min(1, '내용을 입력하세요').max(20000, '내용은 20000자를 초과할 수 없습니다'),
});
// ============================================================
// 사용자 측 — 내 문의
// ============================================================
/** 목록 카드 1건 — 최근 활동 시각·미리보기·활성 세션 ID 포함. */
export const ContactInquiryListItemSchema = z.object({
    id: z.string().cuid2(),
    category: ContactInquiryCategorySchema,
    status: ContactInquiryStatusSchema,
    createdAt: z.string(),
    /** 마지막 메시지(없으면 inquiry.createdAt). */
    lastActivityAt: z.string(),
    /** 마지막 메시지 앞 80자 — 챗봇/에이전트 메시지 모두 후보. */
    messagePreview: z.string(),
    /** 활성 라이브 세션이 있으면 그 sessionId, 아니면 null. */
    openSessionId: z.string().cuid2().nullable(),
});
/** 상세 — 연관 세션들의 메시지를 시간순으로 합쳐 반환. */
export const ContactInquiryDetailSchema = z.object({
    id: z.string().cuid2(),
    category: ContactInquiryCategorySchema,
    status: ContactInquiryStatusSchema,
    name: z.string(),
    email: z.string(),
    initialMessage: z.string(),
    createdAt: z.string(),
    openSessionId: z.string().cuid2().nullable(),
    messages: z.array(LiveChatMessageSchema),
});
/** 재오픈 응답 — 새로 생성됐거나(또는 기존) 활성 라이브 세션 id. */
export const ReopenContactInquiryResponseSchema = z.object({
    sessionId: z.string().cuid2(),
    reused: z.boolean(),
});
//# sourceMappingURL=contact.js.map